import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../CustomComponent/custom_view_button";
// import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Date",
  "Webinar Name",
  "Webinar Start Time",
  "Webinar End Time",
  "Actions",
];
const WebinarTicketsTable = ({ PH = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const goToView = (id) => {
    navigate(`/webinar-tickets/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PH?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.webinarDate || "N/A"}</td>
                <td>{item?.webinar?.webinarName || "N/A"}</td>

                <td>{item?.webinar?.webinarStartTime || "N/A"}</td>
                <td>{item?.webinar?.webinarEndTime || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default WebinarTicketsTable;
